import { youTubeEmbedUrl } from "../lib/videoRef";

/**
 * Simple YouTube embed for lessons whose videoRef is a YouTube link/id.
 * Unlike BunnyPlayer there is no server-signed URL and no automatic progress
 * tracking - completion is driven by the student's "Complete & Continue"
 * button on the lesson page. Suitable for free/intro/bonus content; paid core
 * lessons should stay on Bunny (share-protected).
 */
export function YouTubePlayer({ videoId }: { videoId: string }) {
  return (
    <iframe
      src={youTubeEmbedUrl(videoId)}
      className="bunny-iframe"
      title="YouTube video player"
      loading="lazy"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
    />
  );
}
